<template>
    <b-sidebar
        id="group-form-sidebar"
        :visible="isBuildingFormSidebarActive"
        bg-variant="white"
        sidebar-class="sidebar-lg"
        shadow
        backdrop
        no-header
        right
        @shown="getData(buildingsData)"
        @hidden="resetForm(resetData)"
        @update:visible="val => $emit('update:is-building-form-sidebar-active', val)"
    >
        <template #default="{ hide }">
            <div class="d-flex justify-content-between align-items-center content-sidebar-header px-2 py-1">
                <h5 class="mb-0">Building Form</h5>
                <feather-icon
                class="ml-1 cursor-pointer"
                icon="XIcon"
                size="16"
                @click="hide"
                />
            </div>

            <validation-observer
                ref="refFormObserver"
                v-slot="{ handleSubmit }"
            >
                <b-form
                class="p-2"
                @submit.prevent="handleSubmit(onSubmit)"
                @reset.prevent="resetForm"
                >
                <b-tabs content-class="mt-1" v-if="langsData.length > 0">
                    <b-tab
                    v-for="(lang, key) in langsData"
                    :key="'tab-' + key"
                    :title="lang.name"
                    >
                    <validation-provider
                        :name="'title_' + lang.code"
                        rules="required"
                        v-slot="validationContext"
                    >
                        <b-form-group
                        :label="'Title (' + lang.code + ')'"
                        :label-for="'title_' + lang.code"
                        >
                        <b-form-input
                            :id="'title_' + lang.code"
                            v-model="Data.title[lang.code]"
                            :state="getValidationState(validationContext)"
                            :placeholder="'Title (' + lang.code + ')'"
                            trim
                            autofocus
                        />
                        <b-form-invalid-feedback>
                            {{ validationContext.errors[0] }}
                        </b-form-invalid-feedback>
                        </b-form-group>
                    </validation-provider>
                    </b-tab>
                </b-tabs>

                <b-form-group label="Is Active" label-for="isactive" class="mt-1">
                    <b-form-checkbox
                    id="isactive"
                    v-model="Data.is_active"
                    switch
                    class="custom-control-success"
                    >
                    Active
                    </b-form-checkbox>
                </b-form-group>

                <div class="d-flex mt-2">
                    <b-button
                    v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                    variant="primary"
                    class="mr-2"
                    type="submit"
                    >
                    Submit
                    </b-button>
                    <b-button
                    v-ripple.400="'rgba(186, 191, 199, 0.15)'"
                    type="button"
                    variant="outline-secondary"
                    @click="hide"
                    >
                    Cancel
                    </b-button>
                </div>
                </b-form>
            </validation-observer>
        </template>
    </b-sidebar>
</template>

<script>
import {
    BSidebar, BForm, BFormGroup, BFormInput, BFormCheckbox, BFormInvalidFeedback, BButton,
    BTabs, BTab
} from 'bootstrap-vue'
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import { required, alphaNum, email, password,confirmed } from '@validations'
import { ref } from '@vue/composition-api'
import formValidation from '@core/comp-functions/forms/form-validation'
import Ripple from 'vue-ripple-directive'
import store from '@/store'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import { useToast } from 'vue-toastification/composition'
import router from '@/router'

export default {
    components: {
        BSidebar, BForm, BFormGroup, BFormInput, BFormCheckbox, BFormInvalidFeedback, BButton,
        BTabs, BTab,
        ValidationProvider, ValidationObserver
    },
    directives: {
        Ripple,
    },
    props: {
        isBuildingFormSidebarActive: {
        type: Boolean,
        required: true,
        },
        buildingsData: {
        type: Object,
        default: () => ({}),
        },
        langsData: {
        type: Array,
        default: () => [],
        },
    },
    model: {
        prop: 'isBuildingFormSidebarActive',
        event: 'update:is-building-form-sidebar-active',
    },
    setup(props, { emit }) {
        const toast = useToast()
        const userStorage = JSON.parse(localStorage.getItem('userData'))
        const housePinId = ref(router.currentRoute.params.id);

        const blankData = {
            house_pin_id: housePinId.value,
            created_by: userStorage?.id || null,
            is_active: true,
            title: {},
        }

        const Data = ref({ ...blankData })

        const resetData = () => {
            Data.value = JSON.parse(JSON.stringify(blankData))
        }

        const getData = (data) => {
            if (data?.id) {
                data.is_active = data.is_active? true: false
                Data.value = data
            } else {
                Data.value = blankData
            }
        }

        const onSubmit = async () => {
            let res

            if (Data.value.id) {
                res = await store.dispatch('app-house-pin/updateBuilding', Data.value)
            } else {
                res = await store.dispatch('app-house-pin/AddBuilding', Data.value)
            }

            if (res.data.success) {
                toast({
                    component: ToastificationContent,
                    position: 'top-right',
                    props: {
                        title: 'Success',
                        icon: 'BellIcon',
                        variant: 'success',
                        text: res.data.message,
                    },
                })

                emit('update:is-building-form-sidebar-active', false)
                emit('refetch-data')
            } else {
                toast({
                    component: ToastificationContent,
                    position: 'top-right',
                    props: {
                        title: 'Error',
                        icon: 'BellIcon',
                        variant: 'danger',
                        text: res.data.message,
                    },
                })
            }
        }

        const {
            refFormObserver,
            getValidationState,
            resetForm,
        } = formValidation(resetData)

        return {
            Data,
            onSubmit,
            refFormObserver,
            getValidationState,
            resetForm,
            resetData,
            getData,
        }
    },
}
</script>